export default __webpack_public_path__ + "static/media/cordova.93a23478.svg";